class StickyProgressBar extends HTMLElement {
  constructor() {
    super();
  }

   static observedAttributes = ['_rendered', '_price_update'];

      attributeChangedCallback(name, oldValue, newValue) {
            this[`handle${name}`](oldValue, newValue);
        }
      connectedCallback() {
           if (this.dataset.renderedCartPrice !== '0') {
            this.classList.add('sticky')
            const stickyHeader = document.querySelector('.shopify-section-header-sticky');
            stickyHeader.style.top = `${this.parentElement.offsetHeight}px`;
          }

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
  
            if (event.source === 'cart-items') {
              this.setAttribute('_price_update', event.cartData.items_subtotal_price)
            }
              if (event.source === 'product-form') {

                    try {
              const response = await fetch('/cart.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });

              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }

              const cartData = await response.json();
              this.setAttribute('_price_update', cartData.items_subtotal_price)
              return cartData;

            } catch (error) {
              console.error('Error fetching Shopify cart:', error);
              return null;
            }

            }
            });
                this.observer = new IntersectionObserver(this.handleIntersection, {
                    threshold: 0.5
                });
                this.observer.observe(this);
      }

        disconnectedCallback() {
                if (this.observer) {
                    this.observer.disconnect();
                }
            }
    

    handleIntersection(entries, observer) {

            entries.forEach(entry => {
                if (entry.isIntersecting) {

                }

            });
        }


   handleEvent(e) {

            const {
                nodeName
            } = e.target;

        
        }

        render() {


        }

      
        handle_rendered(oldValue, newValue) {

        }
        handle_price_update(oldValue, newValue) {

          

          const newValueDivided = (newValue / 100).toFixed(2);

          const threshold = (+this.dataset.threshold / 100).toFixed(2);

                let currentValue = newValueDivided;
                let targetValue = threshold;

                let progressBarPercentage = (currentValue / targetValue) * 100; 

                this.querySelector('.sticky-progress-bar-done').style.width = `${progressBarPercentage}%`;

          const difference = threshold - newValueDivided;

           const quantityLeft = document.querySelector('.quantity-left');

           if (difference >= 0) {
            quantityLeft.textContent = `$${difference.toFixed(2)}`;
            document.querySelector('.free-shipping-notice.not-completed').classList.remove('hide-me');
            document.querySelector('.free-shipping-notice.completed').classList.add('hide-me');
           }

           if (difference < 0) {
           document.querySelector('.free-shipping-notice.not-completed').classList.add('hide-me');
           document.querySelector('.free-shipping-notice.completed').classList.remove('hide-me');
           }

          const stickyHeader = document.querySelector('.shopify-section-header-sticky');

           if (this.getAttribute('_price_update') !== '0') {
            this.classList.add('sticky')
            stickyHeader.style.top = `${this.parentElement.offsetHeight}px`;
          }
          else {
             this.classList.remove('sticky')
              stickyHeader.style.top = `0px`;
          }

    
 
        }
        handle_complete(oldValue, newValue) {

 
        }
      }

        
if (!customElements.get('sticky-progress-bar')) {
customElements.define('sticky-progress-bar', StickyProgressBar);
}
